<template>
  <v-layout v-if="!getLoading" row wrap fill-height align-content-start class="examination-detail-page">
    <v-flex xs9 class="pr-2 left mb-2">
      <v-layout row wrap class="webrtc-container">
        <v-flex xs12>
          <Webrtc ref="webrtc" :class="{ hidden: !getWebrtcStatus }" />
        </v-flex>
        <v-flex xs12 class="mb-3" fill-height>
          <examination-finding>
          </examination-finding>
        </v-flex>
      </v-layout>
      <examination-filtering-images horizontal :findings="getFindings" :allImages="getAllImages"
        :landmarksList="getLandmarkList" @imgStatusChange="toggleImgStatus('all', $event)"
        @findingChange="moveImgFromAllToFinding" @landmarkChange="imgLandmarkChange"
        @deleteImg="deleteScreenshot($event)" class="elevation-1"></examination-filtering-images>
    </v-flex>

    <v-flex xs3 class="examination-finding-sidebar pa-2">
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-menu offset-y right>
          <v-btn slot="activator" icon dark>
            <v-icon dark>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile color="primary" @click="setExaminationFinishDialog(true)">
              <v-list-tile-title>Finish</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-layout>
      <v-layout row wrap>
        <voice-command-display
        ></voice-command-display>
      </v-layout>
      <v-layout row wrap>
        <microphone-status
          @triggerRecordKey="triggerRecordKey"
          :isRecording="isRecording"
          :isJudging="isJudging"
        ></microphone-status>
      </v-layout>
      <v-layout class="examination-finding-timer"
       v-if="examinationType != 1">
        <template>
          <time-inputs-group
            :data="getExaminationData.examination"
            horizontal
            hideDetails
            @change="handleExaminationChange">
          </time-inputs-group>
        </template>
      <hr v-if="examinationType != 1" />
      </v-layout>
      <v-layout row wrap class="pt-2 pb-2">
        <v-flex xs12 class="findings-container">
          <quick-commend></quick-commend>
          <insertion-level-input
            v-if="examinationType != 1"
            :data="insertionLevel"
            @change="setInsertionLevelColumn"></insertion-level-input>
          <insertion-length-input
            class="insertion-length-input"
            v-if="examinationType != 1"
            :data="insertionLength"
            @change="setInsertionLengthColumn"></insertion-length-input>
          <hr v-if="examinationType != 1" />
          <preparation-input
            :data="getExaminationData"
            @change="handleExaminationChange"></preparation-input>
        </v-flex>
      </v-layout>
    </v-flex>
    <counting-start-anim v-if="isTimeCounting" @close="setTimeCounting(false)"></counting-start-anim>
    <finish-anim v-if="isTimeFinish" @close="setTimeFinish(false)"></finish-anim>
    <v-dialog v-if="getExaminationData.examination" v-model="examinationFinishDialog" max-width="600px" persistent>
      <examination-finish-dialog :examination="getExaminationData.examination"
        :noFinding="noFinding"
        :hiddenParams="getStoreHiddenParameter" @close="setExaminationFinishDialog(false)"
        @endOfExam="setExaminationStatus()" @change="handleExaminationChange"></examination-finish-dialog>
    </v-dialog>
  </v-layout>
</template>


<script>
  const API_URL = process.env.VUE_APP_API_URL

  import {
    mapGetters,
    mapActions,
    mapMutations,
    mapState
  } from 'vuex'
  import adapter from 'webrtc-adapter'
  import forms from '@/utils/forms'
  import common from '@/utils/common'
  import CountingStartAnim from '@/components/examinations/CountingStartAnim.vue'
  import FinishAnim from '@/components/examinations/FinishAnim.vue'
  import Webrtc from '@/components/Webrtc.vue'
  import ExaminationFinding from '@/components/ExaminationFinding.vue'
  import ExaminationInfo from '@/components/ExaminationInfo.vue'
  import ExaminationFilteringImages from '@/components/examinations/ExaminationFilteringImages.vue'
  import IconButtonWithTooltip from '@/components/IconButtonWithTooltip.vue'
  import ExaminationFindingsFormLevelOne from '@/components/examinations/ExaminationFindingsFormLevelOne.vue'
  import ExaminationFindingsFormLevelTwo from '@/components/examinations/ExaminationFindingsFormLevelTwo.vue'
  import ExaminationBowelCleanseForms from '@/components/examinations/ExaminationBowelCleanseForms.vue'
  import MicrophoneStatus from '@/components/examinations/MicrophoneStatus.vue'
  import VoiceCommandDisplay from '@/components/examinations/VoiceCommandDisplay.vue'
  import ConfirmDialogSmall from '@/components/ConfirmDialogSmall.vue'
  import ExaminationNoFindingDialog from '@/components/examinations/ExaminationNoFindingDialog.vue'
  import ExaminationFinishDialog from '@/components/examinations/ExaminationFinishDialog.vue'
  import TimeInputsGroup from '@/components/TimeInputsGroup.vue'
  import InsertionLevelInput from '@/components/bowelCleanseForms/InsertionLevelInput.vue'
  import PreparationInput from '@/components/bowelCleanseForms/PreparationInput.vue'
  import QuickCommend from '@/components/examinations/QuickCommend.vue'
  import InsertionLengthInput from '@/components/bowelCleanseForms/InsertionLengthInput.vue'

  export default {
    components: {
      TimeInputsGroup,
      Webrtc,
      ExaminationFinding,
      ExaminationInfo,
      ExaminationFilteringImages,
      IconButtonWithTooltip,
      ExaminationFindingsFormLevelOne,
      ExaminationFindingsFormLevelTwo,
      ExaminationBowelCleanseForms,
      ExaminationNoFindingDialog,
      ExaminationFinishDialog,
      ConfirmDialogSmall,
      CountingStartAnim,
      FinishAnim,
      InsertionLevelInput,
      PreparationInput,
      MicrophoneStatus,
      VoiceCommandDisplay,
      QuickCommend,
      InsertionLengthInput
    },

    data() {
      return {
        imagesTabs: 'all',

        deleteDialog: false,
        deleteMessage: '',
        keyPressing: false
      }
    },

    created() {
      this.$store.dispatch('examinations/fetchExaminationDetailAndOtherList', {
        examinationID: this.examinationID,
        accNo: this.accNo
      });
      this.$store.dispatch('examinations/resetStoreHiddenParameterExamination');
      this.$store.dispatch('examinations/resetQuestionsList');
      this.$store.dispatch('examinations/setExaminationFinishDialog', false);
    },

    mounted() {
      //setTimeout(this.addCancelVoiceFocusListener.bind(this), 2000)
    },

    updated() {
      if (Number(this.getExaminationData.examination.status) == 0) {
        this.updateExaminationStatus(this.getExaminationData.examination.id);
      }
    },

    computed: {
      ...mapGetters('examinations', [
        'getDoctorList',
        'getTechnicalStaffList',
        'getExaminationData',
        'getLandmarkList',
        'getExaminationTypeList',
        'getPatient',
        'getQuestionsList',
        'getExaminationFinishDialog',
        'getStoreHiddenParameter',
        'getWebrtcStatus'
      ]),

      ...mapGetters([
        'getLoading'
      ]),

      getExaminationInfo() {
        return this.getExaminationData.examination
      },

      getFindings() {
        return this.getExaminationData ? this.getExaminationData.findings : null
      },

      getFindingsLength() {
        return this.getFindings ? this.getFindings.length : 0
      },

      getAllImages() {
        const images = this.getExaminationData ? this.getExaminationData.all : null
        return images !== null ? images.sort((a, b) => b.id - a.id) : null
      },

      examinationID() {
        if (Number(this.$route.params.examinationID) != 0) {
          return this.$route.params.examinationID;
        } else {
          if (this.getExaminationData != null) {
            return this.getExaminationData.examination.id;
          }
        }
      },

      accNo() {
        return (Number(this.$route.params.accNo) != 0) ? this.$route.params.accNo : 0;
      },

      examinationFinishDialog() {
        return this.getExaminationFinishDialog
      },
      isRecording() {
        return this.getStoreHiddenParameter.isRecording
      },
      isJudging() {
        return this.getStoreHiddenParameter.isJudging
      },
      isTimeCounting() {
        return this.getStoreHiddenParameter.isTimeCounting
      },
      isTimeFinish() {
        return this.getStoreHiddenParameter.isTimeFinish
      },
      examinationType() {
        // 1 => Gastroscopy, 2=> Colonoscopy
        return this.getExaminationData.examination.examination_typeID
      },
      insertionLevel() {
        return this.getExaminationData.examination.insertionLevel
      },
      insertionLength() {
        return this.getExaminationData.examination.insertionLength
      },
      noFinding() {
        return this.getFindings && this.getFindings.length <= 0
      }
    },

    methods: {
      ...mapActions('examinations', [
        'updateExaminationStatus',
        'updateExaminationColumn',
        'addExaminationSedative',
        'deleteExaminationSedative',
        'addExaminationLocation',
        'deleteExaminationLocation',
        'updateExaminationLocationColumn',
        'setExaminationFinishDialog',
        'setStoreHiddenParameter',
        'setRecording',
        'setJudging',
        'setTimeCounting',
        'setTimeFinish'
      ]),

      ...mapActions('screenshots', [
        'setScreenshotGroup',
        'setScreenshotStatus',
        'deleteScreenshot'
      ]),

      test(d) {
        alert(d.id)
        alert(d.column)
        alert(d.value)
      },

      getSelectItems(field) {
        return this[`get${field}List`].map(item => {
          return {
            value: item.id,
            text: item.name
          }
        })
      },

      isEmptyStr(str) {
        return str && (str.trim().replace(' ', '') === '') ? true : false
      },

      setExaminationColumn(column, value) {
        let d = {
          id: this.examinationID,
          column: column,
          value: value
        }
        this.updateExaminationColumn(d)
      },

      setInsertionLevelColumn(event) {
        this.setExaminationColumn('insertionLevel', event);
      },

      setInsertionLengthColumn(event) {
        this.setExaminationColumn('insertionLength', event);
      },

      setExaminationStatus() {
        this.setExaminationColumn('status', 2);
        this.$router.push({
          path: `/home`
        });
      },

      /* same as in report view, we can merge them later */
      toggleImgStatus(n, i) {
        const item = n === 'all' ? this.getAllImages[i] : this.getFindings[n].images[i]
        const currStatus = item.status
        const newStatus = !Number(currStatus) == true ? "1" : "0"
        const imgID = item.id
        const findingID = item.findingID
        const landmarkID = item.landmarkID
        const obj = {
          imgID,
          newStatus,
          item,
          findingID,
          landmarkID
        }

        if (item.findingID !== 0) {
          this.$store.dispatch('examinations/updateScreenshotStatusInFinding', obj)
        }

        this.$store.dispatch('examinations/updateScreenshotStatusInAll', {
          ...obj,
          imgIndex: i
        })
      },

      moveImgFromAllToFinding({
        id,
        newValue
      }) {
        const updateObj = {
          imgID: id,
          newValue
        }

        this.$store.dispatch('examinations/moveImgFromAllToFinding', updateObj)
      },

      imgLandmarkChange({
        id,
        newValue
      }) {
        const updateObj = {
          imgID: id,
          newValue,
          page: 'e'
        }

        this.$store.dispatch('examinations/imgLandmarkChange', updateObj)
      },

      handleSedative(action, event) {
        const examinationSedativeID = event ? event.id : null
        this[`${action}ExaminationSedative`]({
          examinationID: this.examinationID,
          examinationSedativeID
        })
      },

      handleExaminationChange({
        column,
        field,
        event
      }) {
        if (typeof(field) != 'undefined') {
          this.setExaminationColumn(field, event)
        } else {
          this.setExaminationColumn(column, event)
        }
      },

      isEmptyObject: (obj) => common.isEmptyObject(obj),

      triggerRecordKey(eventName) {
        var evObj = new KeyboardEvent(eventName, {
          keyCode: 88,
          which: 88
        });
        // Chrome bug workaround:
        if (evObj.keyCode != 88) {
          evObj.keyCode = 88;
          evObj.which = 88;
        }
        window.dispatchEvent(evObj);

        if (eventName == 'keydown') {
          this.keyPressing = true
          setTimeout(() => {
            if (this.keyPressing !== false) {
              window.dispatchEvent(evObj); // trigger total 3 times to achive  recording requirement
              window.dispatchEvent(evObj);
              this.setRecording(true)
              this.setJudging(true);
            }
          }, 2000)
        } else {
          this.keyPressing = false;
          this.setRecording(false)
          let JUDGING_TIMOUT = 3500;
          setTimeout(() => { this.setJudging(false) }, JUDGING_TIMOUT);
        }
      },
      addCancelVoiceFocusListener() {
        const main = document.getElementsByTagName('main')[0];
        const _this = this

        main.addEventListener('click', () => {
          _this.setStoreHiddenParameter({
            target: 'focus',
            value: ''
          })
        })
      },

    }
  }

</script>
<style lang="scss">
  .insertion-length-input input[type=text]{
    color: #5A81A3 !important;
  }
</style>
<style lang="scss" scoped>
  @import '@/styles/pages/page_examinationDetail.scss';
  @import '@/styles/components/textInputsTextfield.scss';

  // #hihi .v-text-field__slot >>> input {
  //   color:red !important
  // }
  .examination-finding-sidebar {
    background-color: #000000; // color-code: background
    color: #98999a; //color-code: sidebar text color
    font-weight: bold;
  }

  .hidden {
    visibility: hidden;
    position: absolute;
    top: 0;
  }

  hr {
    color: #252627; // color-code
  }
</style>
